<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.market.feeTitle') }}</span>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-6">
                    <v-col cols="12">
                        <v-select
                            :items="feeTypeItems"
                            :label="$vuetify.lang.t('$vuetify.custom.market.feeWay')"
                            hide-details
                            solo
                            v-model="formData.type"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            type="number"
                            :label="$vuetify.lang.t('$vuetify.custom.market.feeMoney')"
                            v-model="formData.money"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            :label="$vuetify.lang.t('$vuetify.custom.market.feeContent')"
                            v-model="formData.content"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-row>
                    <v-col cols="6">
                        <v-btn color="error" dark @click="hiddenDialog">{{
                                $vuetify.lang.t('$vuetify.custom.cancelBtn')
                            }}
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn color="success" dark @click="addFee">{{ $vuetify.lang.t('$vuetify.custom.okBtn') }}</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>
export default {
    name: 'mark-follow',
    model: {
        prop: 'feeDialog',
        event: 'parent-event'
    },
    props: {
        feeId:String,
        feeDialog: Boolean
    },
    mounted() {
        this.formData.clewId = this.feeId
    },
    data: () => ({
        feeTypeItems: [
            {text: '支付宝', value: '1'},
            {text: '微信', value: '2'},
            {text: '银行卡', value: '3'},
            {text: '贷款', value: '4'},
        ],
        formData: {
            clewId:'',
            type: '',
            money: '',
            content: '',
        },

    }),
    watch: {
        feeDialog() {
            if (this.feeDialog) {
                this.formData.clewId = this.feeId
            }
        }
    },
    methods: {
        addFee(){
            if (this.$refs.form.validate()) {
                this.$api.payRecord.addClewPayRecord(this.formData).then(data => {
                    if (data.flag) {
                        this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.addSuccess'));
                        this.$emit('queryFee')
                        this.hiddenDialog();
                    } else {
                        this.$dialog.alert(data.msg)
                    }
                })
            }
        },
        hiddenDialog() {
            this.$refs.form.reset()
            this.$emit('parent-event', false);
        },
    },
}
</script>
